<!--<iframe [src]="safeUrl" style="width:100%;height:100%;border:none;"></iframe>-->
<div class="col-lg-12" id="container-hubspot">
  <h3 class="title">Completá tus datos para recibir más información </h3>

  <!--<div id="hubspot-form-modal">
    </div>-->
  <app-form-hubspot portalId="23647426" formId="b2e6899b-83b4-4a49-92ff-92360afdd10d"></app-form-hubspot>

</div>